<template lang="html">
  <ul class="labeled-list container">
    <LabeledListItem v-for="child in resource.children" :key="child.id" :resource="child" />
  </ul>
</template>

<script>
import editable from '@i22/frontend-cms-utils/mixins/editable'
import LabeledListItem from 'beisheim/components/blocks/labeled-list-item'
import VueTypes from 'vue-types'

export default {
  components: {
    LabeledListItem
  },
  mixins: [ editable ],
  props: {
    content: VueTypes.shape({
      items: VueTypes.arrayOf(VueTypes.shape({
        jsonPath: VueTypes.string,
        headline: VueTypes.object.isRequired,
        contentList: VueTypes.array.isRequired
      }))
    }).loose,
    metaInformation: VueTypes.object
  }
}
</script>

<style lang="scss">
@import '~beisheim/scss/colors';
@import '~beisheim/scss/scale';
@import '~beisheim/scss/grid';

.labeled-list {
  margin-top: scale(10);
  margin-bottom: scale(10);
}

.labeled-list__item {
  border-top: 1px solid gray(4);
}
</style>
